export const SUPPORTED_LANGUAGES: string[] = [
  'English',
  'Scots Gaelic',
  'Welsh',
  'Irish',
  'French',
  'German',
  'Spanish',
  'Italian',
  'Portuguese',
  'Dutch',
  'Polish',
  'Romanian',
  'Ukrainian',
  'Russian',
  'Arabic',
  'Hindi',
  'Urdu',
  'Punjabi',
  'Bengali',
  'Gujarati',
  'Tamil',
  'Mandarin Chinese',
  'Cantonese',
  'Japanese',
  'Korean',
  'Turkish',
  'Somali',
  'Swahili',
  'Tagalog',
  'Greek',
];
